import { Banknote } from "lucide-react";
import classNames from "classnames";

export function FeatureCard({ title, description, variant = "left", className }: { title?: string; description?: string; variant?: string; className?: string }) {
  return (
    <article
      className={classNames(
        "rounded-xl border bg-card p-4 shadow-sm space-y-2",
        "sm:p-3",
        className,
      )}
      aria-label={title}
    >
      <div className="flex gap-2 items-center">
        <span
          className={classNames(
            "inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md",
            "bg-[#FF4C0099] text-accent-foreground",
            "sm:h-6 sm:w-6"
          )}
          aria-hidden="true"
        >
          <Banknote className="text-[white]" height={20} />
        </span>
        <h3 className="text-sm font-medium leading-snug sm:text-xs">{title}</h3>
      </div>
      <p className="text-xs text-[#4D4D4D] font-medium sm:text-[11px] sm:leading-tight">{description}</p>
    </article>
  );
}